import * as Yup from 'yup'
import { NAME, STORES } from './fields'

export const validationSchema = Yup.object({
  [NAME]: Yup.string().required('Name required'),
  [STORES]: Yup.array().min(1, 'At least one store must be selected').required('Stores required')
})
